<template>
    <q-dialog v-model="alertOption.open" @hide="closeAlert()" persistent class="alert">
        <q-card class="q-dialog-plugin">
            <template v-if="alertOption?.close">
                <q-card-section class="row items-center q-pb-none" style="padding: 2vmin 2vmin 1vmin">
                    <div style="font-size: 1vw; font-weight: 700">{{ alertOption?.title }}</div>
                    <q-space /> 
                    <q-btn class="close" icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-separator />
            </template>
            <div style="padding: 3.33vmin" :style="!alertOption.close && 'margin-top: 1.8vmin;'">
                <div class="alert__message" v-html="alertOption.message || ''"></div>
                <q-btn class="alert__btn" color="primary" size="lg" style="width: 100%" :label="alertOption?.buttonText || '닫기'" @keydown.enter="closeAlert(true)" @click="closeAlert(true)" />
            </div>
        </q-card>
    </q-dialog>
</template>

<script>
import { computed, onMounted } from 'vue';
import { DialogStore } from '@/store/modules/dialog';
import { soundEffect } from '@/helpers/soundEffect';

export default {
    name: 'alert-dialog',
    setup() {
        const store = DialogStore();
        const alertOption = computed(() => store.alertOption);

        const closeAlert = () => {
            // console.log('close alert');
            store.closeAlertDialog(true);
            // store.commit('dialogStore/closeAlertDialog');
        };

        return {
            alertOption,
            closeAlert,
        };
    },
};

onMounted(() => {
    // soundPopup();
    soundEffect('popup');
});
</script>

<style scoped lang="scss">
.alert {
    .q-card {
        width: 40%;
        max-width: 580px;
        border-radius: 3.33vmin;
    }

    &__message {
        padding: 0.4vmin 1.87vmin 5vmin;
        // font-size: 2.12vmin;
        font-size: 1.7vw;
        font-weight: 700;
        text-align: center;
        white-space: break-spaces;
    }

    &__btn {
        border-radius: 1vmin;
        padding: 2vmin 0vmin;
        font-size: 1.2vw;
    }
}

::v-deep {
    .alert__btn {
        .block {
            font-size: 1.2vw;
            font-weight: 700;
        }
    }
}

.q-btn--actionable.q-btn--standard:before {
    box-shadow: inherit;
}
</style>
